<template lang="pug">
.realtime-trans
  .tt
    router-link(to="/review")
      img(src='/new/img/rt/rt-icon.png')
  .ccon
    .rtt-wrap
      .vv-rtt
        div(v-for="x in topTenList")
          .rttbox
            .rcon
              div
                span {{ x.member_id }}
                //- span.time {{$moment(x.action_date).locale(getLanguageDisplay).fromNow()}}
                span {{ $tc('ui.topten_'+x.transfer_type) }}
            .rcon
              div
                span.amo PHP {{ x.transfer_amount.toFixed(2) }}
  .tl.animate__animated.animate__flash.animate__infinite
    img(src="/new/img/rt/rt-live.png")
//- .transaction-wrapper
  .container
    .transaction-row
      .transaction-status-mobile
        .transaction-title {{$t('ui.real_time_trans')}}
        template(v-if="!loading")
          .swiper.swiper-transaction-mobile(v-if="realTimeList.length > 0")
            .swiper-wrapper
              .swiper-slide(v-for="trans in realTimeList")
                .transaction-details
                  .transaction-time.d-flex.flex-column
                    div {{$moment(trans.action_date).format("HH:mm")}} ({{$moment(trans.action_date).format("DD/MM")}})
                    //- div {{$moment(trans.action_date).format("DD-MM")}}
                  .transaction-id 
                    .member-icon
                      i.fa-solid.fa-user
                    .member-id {{trans.account_id}}
                  .transaction-type
                    span.text-green(:class="{'text-green' : trans.action_type === 'DEPOSIT', 'text-purple' : trans.action_type === 'WITHDRAWAL'}") {{$t('ui.'+ (trans.action_type.toLowerCase()))}}
                  .transaction-amount
                    span.text-green {{trans.amount}}
            .swiper-pagination
          .d-flex.justify-content-center.my-2(v-else) {{$t('ui.no_record')}}
        template(v-else)
          .text-center.my-2
            i.fas.fa-duotone.fa-spinner.fa-spin-pulse
      .referral
        router-link(to="promotions")
          .referral-pic
            img.img-fluid(src='img/referral.jpg')            
        .referral-wrapper.justify-content-evenly(v-if="$store.getters.isLoggedIn")
          .referral-link 
            i.fa-solid.fa-user-group 
            | : {{getReferralcode}}
          a(href='javascript:void(0)' @click="copyClipboard()")
            .btn-main.btn-referral-left {{$t('ui.copy_referral')}}
          //- a(href='javascript:void(0)' @click="copyClipboard()")
            .btn-sub.btn-referral-right {{$t('ui.invite_friend')}}
        .referral-wrapper.justify-content-evenly(v-else)
          router-link(to="login")
            .btn-main.btn-referral-left {{$t('ui.login_now')}}
          router-link(to="register")
            .btn-sub.btn-referral-right {{$t('ui.register_now')}}
      .transaction-status-desktop.flex-fill
        .transaction-title {{$t('ui.real_time')}} &nbsp;
          span.text-green {{$t('ui.deposit')}} &nbsp;
          | {{$t('ui.status')}}
        template(v-if="!loading")
          .swiper.swiper-transaction-desktop.swiper-deposit(v-if="depositList.length > 0")
            .swiper-wrapper
              .swiper-slide(v-for="deposit in depositList")
                .transaction-details
                  .transaction-time {{$moment(deposit.action_date).format("DD-MM-YYYY HH:mm")}}
                  .transaction-id
                    .member-icon
                      i.fa-solid.fa-user
                    .member-id {{deposit.account_id}}
                  .transaction-amount
                    span.text-green {{deposit.amount}}
            .swiper-pagination
          .d-flex.justify-content-center.my-2(v-else) {{$t('ui.no_record')}}
        template(v-else)
          .text-center.my-2
            i.fas.fa-duotone.fa-spinner.fa-spin-pulse
      .transaction-status-desktop.flex-fill
        .transaction-title {{$t('ui.real_time')}} &nbsp;
          span.text-purple {{$t('ui.withdrawal')}} &nbsp;
          | {{$t('ui.status')}}
        template(v-if="!loading")
          .swiper.swiper-transaction-desktop.swiper-withdrawal(v-if="withdrawalList.length > 0")
            .swiper-wrapper
              .swiper-slide(v-for="withdraw in withdrawalList")
                .transaction-details
                  .transaction-time {{$moment(withdraw.action_date).format("DD-MM-YYYY HH:mm")}}
                  .transaction-id
                    .member-icon
                      i.fa-solid.fa-user
                    .member-id {{withdraw.account_id}}
                  .transaction-amount
                    span.text-purple {{withdraw.amount}}
            .swiper-pagination
          .d-flex.justify-content-center.my-2(v-else) {{$t('ui.no_record')}}
        template(v-else)
          .text-center.my-2
            i.fas.fa-duotone.fa-spinner.fa-spin-pulse
</template>
<script>
import config from "@/config";
export default {
  data(){
    return{
      topTenList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
    }
  },
  computed:{
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    getLanguageDisplay(){
      return this.$tc(`ui.language.${this.$store.getters.language}`) || this.$tc('ui.language.en')
    },
    // getReferralcode(){
    //   return this.$store.state.user.account.referral_code || ""
    // },
  },
  created(){
    this.getTopTenDepWit()
  },
  beforeUpdate(){
    $('.vv-rtt').filter('.slick-initialized').slick('unslick');
  },
  updated(){
    $('.vv-rtt').not('.slick-initialized').slick({
      dots: false,
      infinite: true,
      arrows: false,
      speed: 300,
      autoplaySpeed: 2000,
      slidesToShow: 2,
      slidesToScroll: 1,
      pauseOnFocus: false,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
              slidesToShow: 1
          }
        }
      ]
    });
  },
  mounted(){
    
  },
  methods:{
    getTopTenDepWit(){  //get top ten deposit withdrawal
      let url = config.getTopTenDepositWithdraw();
      // var json = {
      //   app_id : config.app_id
      // }
      this.$http.get(url).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }

              this.feedback.status = response.status;
              if (this.feedback.success == true) {
                this.topTenList = response.data.value
              } else {
                var vm = this;
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            var vm = this;
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
            }
          }
        },
        function(response) {
          // this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
          }
        }
      );
      
    },
    // copyClipboard(){
    //   if(!this.sessionToken) return;

    //   const g = document.createElement('div');
    //   g.id = "urlLink";
    //   g.innerHTML = window.location.protocol + "//" +window.location.hostname +"/register?ref="+ this.getReferralcode
    //   document.body.appendChild(g);
    //   var range = document.createRange();
    //   range.selectNode(document.getElementById("urlLink"));
    //   window.getSelection().removeAllRanges(); // clear current selection
    //   window.getSelection().addRange(range); // to select text
    //   document.execCommand("copy");
    //   window.getSelection().removeAllRanges();
    //   document.body.removeChild(g);
    //   this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.copy_clipboard"), "success", this)
    // },
    // getRealTimeTrans(){
    //   this.loading= true
    //   let method = "dpwh"
    //   this.$store
    //     .dispatch("user/getRealTimeTrans", { method })
    //     .then(response => {
    //       if (response.success == true) {
    //         this.depositList = response.data.Deposit
    //         this.withdrawalList = response.data.Withdrawal
    //         this.realTimeList = [...this.depositList, ...this.withdrawalList]
    //         this.realTimeList.sort((a, b) => b.action_date > a.action_date ? 1 : b.action_date < a.action_date ? -1 : 0)
    //         this.loading= false
    //         this.$nextTick(() => this.initSwiper());
    //       } else {  
    //         this.loading= false           
    //         if((typeof response.status) != 'object'){
    //           this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //         }
    //       }
    //     })
    //     .catch(response => {
    //       this.loading= false
    //       if((typeof response.status) != 'object'){
    //         this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
    //       }
    //     });
    // },
    // initSwiper(){
    //   var swiper4 = new Swiper(".swiper-transaction-mobile", {
    //     direction: "vertical",
    //     slidesPerView: 8,
    //     loop: true,
    //     autoplay: {
    //       delay: 2500,
    //       disableOnInteraction: false,
    //     },
    //     breakpoints: {
    //       992: {
    //         slidesPerView: 6,
    //       },
    //     },
    //   });
    //   var swiper5 = new Swiper(".swiper-deposit", {
    //     direction: "vertical",
    //     slidesPerView: 6,
    //     loop: true,
    //     autoplay: {
    //       delay: 2500,
    //       disableOnInteraction: false,
    //     },
    //   });

    //   var swiper6 = new Swiper(".swiper-withdrawal", {
    //       direction: "vertical",
    //       slidesPerView: 6,
    //       loop: true,
    //       autoplay: {
    //         delay: 2500,
    //         disableOnInteraction: false,
    //       },
    //   });
    // },
  }
}
</script>
<style lang="scss" scoped>
.transaction-details{
  // height: 40px !important;
  @media(max-width: 767px){
    font-size: 11px;
  }
}
.referral-link{
  line-height: 35px;
}
</style>